// single pages
import homePage from '../pages/home/Home.vue'
// import newsPage from '../pages/news/NewsPage.vue'
// import showingPage from '../pages/showing/Showing'
// import comingPage from '../pages/coming/Coming'
// import historyPage from '../pages/history/History'
// import introPage from '../pages/intro/Intro'
// import productPage from '../pages/product/Product'
// import addressPage from '../pages/address/Address'
// import newsDetailsPage from '../pages/news/NewsDetailsPage'
// import moviePage from '../pages/movie/Movie'
// import enterpriseInfoPage from '../pages/enterpriseInfo/EnterpriseInfo'
// import privacyPolicyPage from '../pages/privacyPolicy/PrivacyPolicy'
// import termPage from '../pages/term/Term'
// import notFoundPage from '../pages/NotFound.vue'

export const routes = [
  {
    path: '/schedule',
    name: 'home',
    component: homePage
  }
  // {
  //   path: '/news',
  //   name: 'news',
  //   component: newsPage
  // },
  // {
  //   path: '/showing',
  //   name: 'showing',
  //   component: showingPage
  // },
  // {
  //   path: '/coming',
  //   name: 'coming',
  //   component: comingPage
  // },
  // {
  //   path: '/history',
  //   name: 'history',
  //   component: historyPage
  // },
  // {
  //   path: '/intro',
  //   name: 'intro',
  //   component: introPage
  // },
  // {
  //   path: '/product/:id',
  //   name: 'product',
  //   component: productPage
  // },
  // {
  //   path: '/address',
  //   name: 'address',
  //   component: addressPage
  // },
  // {
  //   path: '/news/:id',
  //   name: 'news-details',
  //   component: newsDetailsPage
  // },
  // {
  //   path: '/:movieStatus/:id',
  //   name: 'movie',
  //   component: moviePage
  // },
  // {
  //   path: '/enterprise-info',
  //   name: 'enterprise-info',
  //   component: enterpriseInfoPage
  // },
  // {
  //   path: '/privacy-policy',
  //   name: 'privacy-policy',
  //   component: privacyPolicyPage
  // },
  // {
  //   path: '/term',
  //   name: 'term',
  //   component: termPage
  // },
  // {
  //   path: '*',
  //   name: 'notFound',
  //   component: notFoundPage
  // }
]
